
import { useState } from 'react';
import { Prayer } from '@/types/prayer';

interface UseCommentsDialogReturn {
  isCommentsOpen: boolean;
  selectedPrayerForComments: Prayer | null;
  openComments: (prayer: Prayer) => void;
  closeComments: () => void;
}

export function useCommentsDialog(): UseCommentsDialogReturn {
  const [isCommentsOpen, setIsCommentsOpen] = useState(false);
  const [selectedPrayerForComments, setSelectedPrayerForComments] = useState<Prayer | null>(null);

  const openComments = (prayer: Prayer) => {
    setSelectedPrayerForComments(prayer);
    setIsCommentsOpen(true);
  };

  const closeComments = () => {
    setIsCommentsOpen(false);
    setSelectedPrayerForComments(null);
  };

  return {
    isCommentsOpen,
    selectedPrayerForComments,
    openComments,
    closeComments
  };
}
